import {observable, computed, action, makeAutoObservable} from "mobx";
import * as Api from "utils/api/api";

class VideoStore {
  list = [];
  PAGE_SIZE = 8;
  pageSize = 8;
  pageNum = 1;
  title = "";
  currentCategoryIndex = 0;
  refreshing = false;

  constructor() {
    makeAutoObservable(this)
  }
  init() {
    this.list = [];
    this.pageSize = 8;
    this.pageNum = 1;
    this.title = "";
    this.currentCategoryIndex = 0;
    this.refreshing = false;
  }

  async fetchList() {
    if (this.refreshing) {
      return;
    }
    try {
      this.refreshing = true;
      const { pageSize, pageNum, title } = this;
      const { list } = await Api.videoList({
        pageSize,
        pageNum,
        title,
      });

      this.list = list;
    } catch (error) {
    } finally {
      this.refreshing = false;
    }
  }

}

const store = new VideoStore();

export default store;
